import React from 'react';
import { IndexPage } from '../layouts/IndexPage';

const Page = () => <IndexPage title="Home" />;
export default Page;
